import React from 'react';
import sc from 'styled-components';
import { Spin } from 'antd';

import { NOT_LOADED } from '../../store/sharedConstants';

const CenterDiv = sc.div`
  margin: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

 `;

export default (bottle) => {
  /* eslint-disable react/prop-types */

  bottle.factory('LoadingScreen', () => ({
    userStatus,
  }) => {
    if (userStatus === NOT_LOADED) {
      return (
        <CenterDiv><Spin /></CenterDiv>
      );
    }
    return (
      <CenterDiv><Spin size="large" /></CenterDiv>
    );
  });
};
